var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plus-button",on:{"click":function($event){return _vm.$emit('clicked')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }